import React from "react";
import Sidebar from "@/components/Sidebar";

export default function Layout({ children, title, subtitle, actions }) {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Sidebar />
      <div className="lg:ml-64">
        <header className="bg-white border-b border-gray-200 h-16 flex items-center justify-between px-6 sm:px-8 sticky top-0 z-30">
          <div>
            <h1 className="font-display text-lg sm:text-xl font-semibold text-slate-900 leading-tight" data-testid="page-title">{title}</h1>
            {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
          </div>
          <div className="flex items-center gap-2">{actions}</div>
        </header>
        <main className="p-6 sm:p-8">{children}</main>
      </div>
    </div>
  );
}
